import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-favorite',
  components: {},
})
export default class DisplayFieldFavorite extends mixins(AbstractDisplayField) {}
